import React from 'react';
import { FormikProps } from 'formik';
import { FormikTextInput } from 'src/common/form/formik/text-input';
import { FormikTextarea } from 'src/common/form/formik/textarea';
import { JourneyFormik, JourneyForm } from 'src/common/JourneyFormik';
import { ToggleButton } from '../../components/dashboard/create-journey-modal';
import { NativeFormCheckboxesInput, NativeFormElement } from '../store';
import { AutoSubmitForm } from '../auto-submit-form';
import { NativeFormConfigInputOptions } from './input-options';

type NativeFormConfigCheckboxesFormProps<T> = {
  onSubmit: (values: Partial<T>) => void;
} & T;

export const NativeFormConfigCheckboxesForm = <T extends NativeFormElement>({
  onSubmit,
  ...props
}: NativeFormConfigCheckboxesFormProps<T>) => {
  const formProps = props as unknown as NativeFormCheckboxesInput;
  const formikParams = {
    initialValues: { ...props },
    // validationSchema: getValidationSchema('checkbox', formProps.required),
    onSubmit,
    validateOnChange: true,
  };

  return (
    <JourneyFormik {...formikParams}>
      {({ setFieldValue }: FormikProps<Record<string, string | boolean>>) => (
        <JourneyForm className='flex flex-col gap-4 shrink-0'>
          <AutoSubmitForm />
          <FormikTextInput
            isNeue
            labelClassName='text-bedrock-p-strong text-neue-journey-fg'
            id='label'
            name='label'
            required
            type='text'
            label='Label'
          />
          <FormikTextarea
            id='description'
            name='description'
            inputClasses='h-24 bg-neue-journey-bg-90 !text-neue-journey-fg'
            label='Description'
            labelClassName='block text-bedrock-p-strong text-neue-journey-fg'
            hideOptional
          />
          <div className='flex flex-col gap-2'>
            <div className='flex flex-col gap-2'>
              <span className='text-neue-journey-medium-strong'>Required</span>
              <div className='flex gap-2'>
                <ToggleButton
                  selected={formProps.required}
                  label={<span>Yes</span>}
                  onClick={() => {
                    setFieldValue('required', true);
                  }}
                />
                <ToggleButton
                  selected={!formProps.required}
                  label={<span>No</span>}
                  onClick={() => {
                    setFieldValue('required', false);
                  }}
                />
              </div>
            </div>
            <div className='flex flex-col gap-2'>
              <span className='text-neue-journey-medium-strong'>Orientation</span>
              <div className='flex gap-2'>
                <ToggleButton
                  selected={formProps.orientation === 'vertical'}
                  label={<span>Vertical</span>}
                  onClick={() => {
                    setFieldValue('orientation', 'vertical');
                  }}
                />
                <ToggleButton
                  selected={formProps.orientation === 'horizontal'}
                  label={<span>Horizontal</span>}
                  onClick={() => {
                    setFieldValue('orientation', 'horizontal');
                  }}
                />
              </div>
            </div>
          </div>
          <NativeFormConfigInputOptions
            options={formProps.options}
            onAdd={() => {
              setFieldValue('options', [
                ...formProps.options,
                {
                  label: `Checkbox ${formProps.options.length + 1}`,
                  value: `Checkbox_${formProps.options.length + 1}`,
                },
              ]);
            }}
            onRemove={(index) => {
              setFieldValue(
                'options',
                formProps.options.filter((_, i) => i !== index)
              );
            }}
          />
        </JourneyForm>
      )}
    </JourneyFormik>
  );
};
